import {AccessCode, Platform} from "@variocube/app-api";
import {EventSupportingApp} from "@variocube/app-common";
import * as React from "react";
import icon from "./img/icon-usecase_delivery.svg";
import {loadMockData} from "./mock";
import {PoBoxMain} from "./PoBoxMain";
import {render} from "react-dom";
import {LocalizationProvider, SUPPORTED_LANGUAGES} from "../i18n";
import {AppContext, AppErrorBoundary, ThemeProvider} from "@variocube/cube-ui";

export default class extends EventSupportingApp {

    constructor(platform: Platform) {
        super(platform, icon, "#a8202a", SUPPORTED_LANGUAGES);
    }

    render(appRoot: Element) {
        const appContext = {
            platform: this.platform,
            appEventSupport: this.eventSupport
        };
        const defaultTheme = {
            colorBackground: "#ffffff",
            colorForeground: "#333333",
            colorPrimary: "#a8202a",
        };
        render((
            <AppContext.Provider value={appContext}>
                <ThemeProvider defaultTheme={defaultTheme}>
                    <AppErrorBoundary appId={this.platform.appId} cubeId={this.platform.hostname}>
                        <LocalizationProvider app={this}>
                            <PoBoxMain/>
                        </LocalizationProvider>
                    </AppErrorBoundary>
                </ThemeProvider>
            </AppContext.Provider>
        ), appRoot);
    }

    async canProcessAccessCode({code}: AccessCode) {
        const occupancies = await this.platform.getOccupancies(code);
        return occupancies.length > 0;
    }

    loadMockData() {
        return loadMockData(this.platform);
    }
}


